import { useState, useEffect, useContext } from 'react';

import { LiveReserveContext } from '../../LiveLessonReseveContext';
import LiveReserveSubmitConfirm from './confirm/LiveReserveSubmitConfirm';

import {
  isFilledLiveReserveRequestPrefs,
} from '../../../../../../models/lesson/live/reserve/request/LiveReserveRequest';


// 予約ボタン
function LiveReserveSubmit() {

  const {
    formRef, selectedScheduleId, selectedSituation,
    isRequestMode, requestPrefs,
  } = useContext(LiveReserveContext);

  const [canReserve, setCanReserve] = useState<boolean>(false);
  const [isDispConfirm, setIsDispConfirm] = useState<boolean>(false);
  // 押したのに進めないときの案内（何が足りないか）
  const [errorMessage, setErrorMessage] = useState<string>('');

  // 日程が決まっているか（予約は枠のID、リクエストは第1〜第3希望）
  const isDateReady = isRequestMode
    ? isFilledLiveReserveRequestPrefs(requestPrefs)
    : Boolean(selectedScheduleId);


  // ★SPEAKOUT-1853 リクエストは枠のID(selectedScheduleId)を持たないので、
  //   代わりに希望日時が第1〜第3までそろっているかを見る。実践したい内容はどちらも必須。
  useEffect(() => {
    const newCanReserve = Boolean(isDateReady && selectedSituation);
    setCanReserve(newCanReserve);
    // 足りない項目が埋まったら案内は引っ込める
    if (newCanReserve) setErrorMessage('');
  }, [isDateReady, selectedSituation])


  const onPress = () => {
    if(canReserve) {
      // 予約確認
      setErrorMessage('');
      setIsDispConfirm(true);
      return;
    }

    // 🔴 SPEAKOUT-1853 以前はフォームの先頭（講師選択）へスクロールするだけで、
    //   押した人には【何が足りないのか】も【押したことが伝わったのか】も分からなかった
    //   （ボタンがグレーなだけで、押しても無反応に見える）。
    //   足りない項目を名指しして、その欄まで運ぶ。
    const isDate = !isDateReady;
    setErrorMessage(
      isDate
        ? (isRequestMode ? 'ご希望の日時を入力してください' : 'レッスンの日程を選んでください')
        : '実践したい内容を選んでください'
    );
    const target = document.getElementById(isDate ? 'live_reserve_date' : 'live_reserve_situation');
    (target || formRef?.current)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


  return (
    <>
      {/* 予約ボタン */}
      <div className="text-center">
        <button
          type="button"
          className="btn btn-success btn_customize btn_lg"
          style={{
            width: '80%',
            fontSize: '130%',
            letterSpacing: '0.05em',
            whiteSpace: 'normal',   // .btn は既定 nowrap＝長い文言が親からはみ出す

            ...( !canReserve
              ? { backgroundColor: '#7d7d7d' }
              : {}
            )
          }}
          onClick={onPress}
        >
          {isRequestMode ? '予約リクエストする' : '予約する'}
          &nbsp;<i className="fas fa-chevron-circle-right"></i>
        </button>

        {errorMessage &&
          <p style={{
            color: '#a94442',
            fontWeight: 'bold',
            margin: '10px auto 0',
            fontSize: '16px',
          }}>{errorMessage}</p>
        }
      </div>

      {/* 確認モーダル */}
      <LiveReserveSubmitConfirm
        isDispConfirm={isDispConfirm}
        setIsDispConfirm={setIsDispConfirm}
      />
    </>
  );
}
  
export default LiveReserveSubmit;